"use client";
import { create } from "zustand";
import { ReportQueuePropsType } from "@/app/types/typeConfig/report";

interface ReportStore {
  reportRequestQueue: ReportQueuePropsType[];
  addToReportQueueStore: (item: ReportQueuePropsType) => void;
  batchToReportQueueStore: (items: ReportQueuePropsType[]) => void;
  replaceReportQueueStore: (items: ReportQueuePropsType[]) => void;
}

export const useReportStore = create<ReportStore>((set) => ({
  reportRequestQueue: [],

  addToReportQueueStore: (item) => {
    set((state) => ({
      reportRequestQueue: [...state.reportRequestQueue, item],
    }));
  },

  batchToReportQueueStore: (items) => {
    set((state) => ({
      reportRequestQueue: [...state.reportRequestQueue, ...items],
    }));
  },

  replaceReportQueueStore: (items) => {
    set({ reportRequestQueue: items });
  },
}));
